<nav class="d-flex px-3 pb-3 justify-content-start align-items-center w-100" #navbar [ngClass]="hideNavbarMenu() ? 'py-lg-2' : 'py-lg-0'">
  <!-- BORROWER SELECTION -->
  <form
    [formGroup]="appForm"
    class="application-dropdown-container me-lg-3 d-flex align-items-center"
    [attr.automation-id]="'dropdown-select-app' | qaSlug"
  >
    <!--
    NOTE: The PrimeNG dropdown control was having troubles with the changing and temporary
    values in the Application options list and was causing bad states to occur.  In order to still
    leverage the styling of the PrimeNg dropdown, still using the native select input as the primary
    driver for the workflow just hidden.  The PrimeNG control will pass it's value to the hidden input.
    -->
    <select formControlName="appSelector" class="cmg-select w-100" hidden>
      @for (app of applications$ | async; track app) {
        <option [ngValue]="app.id">{{ app.value }}</option>
      }
    </select>
    <p-select
      appendTo="body"
      class="application-selector w-100"
      formControlName="appSelectorDisplay"
      optionLabel="value"
      optionValue="id"
      styleClass="w-100"
      [options]="applicationsOptions"
      (onChange)="onApplicationSelectorDisplayChange($event)"
    >
      <ng-template let-item pTemplate="item">
        @if (item.id !== -1) {
          <div class="option">{{ item.value }}</div>
        }
        @if (item.id === -1) {
          <div class="option option-fixed-action">
            <span> <i class="pi pi-plus-circle me-2"></i>{{ item.value }} </span>
          </div>
        }
      </ng-template>
      <ng-template let-item pTemplate="selectedItem">
        <div class="d-flex justify-content-between flex-fill align-items-center">
          <span> <i class="pi pi-user me-2"></i>{{ item.name }} </span>
        </div>
      </ng-template>
    </p-select>
  </form>
  @if ((displayManageBorrowersDropdown$ | async) === true) {
    <cmg-split-button
      class="manage-application-button me-lg-3"
      [menuItems]="manageApplicationItems"
      [disabled]="isLoanLockedForManageBorrowers$ | async"
    >
      <i button-content class="pi pi-user-plus"></i>
      <ng-template let-item let-index="index" #optionTemplate>
        <div
          class="cmg-split-button-menu-item d-inline-flex p-3 align-items-center justify-content-between cursor-pointer text-color"
          (click)="item.command()"
        >
          @if (item.icon) {
            <i class="{{ item.icon }}"></i>
          }
          <span>{{ item.label }}</span>
        </div>
      </ng-template>
    </cmg-split-button>
  }
  <!-- MOBILE SECTION DROPDOWN -->
  @if (!hideNavbarMenu()) {
    <div class="nav-section-mobile d-flex d-lg-none">
      <p-select
        [appendTo]="navbar"
        class="mobile-section-dropdown w-100"
        optionValue="sectionType"
        optionLabel="text"
        styleClass="w-100"
        [options]="navBarItems"
        (onChange)="onMobileNavSelect($event.value, navBarItems)"
        [(ngModel)]="activeNavbarItem"
      />
    </div>
  }
  <!-- DESKTOP SECTIONS -->
  @if (
    !hideNavbarMenu() && {
      isStartOfScroll: isStartOfScroll$ | async,
      isEndOfScroll: isEndOfScroll$ | async,
    };
    as nav
  ) {
    <div class="nav-section-container d-none d-lg-flex align-items-center">
      <p-button
        (click)="scrollNav('left')"
        [attr.automation-id]="'nav-left-scroll' | qaSlug"
        [class.d-none]="nav.isStartOfScroll && nav.isEndOfScroll"
        [disabled]="nav.isStartOfScroll"
        class="scroll-icon me-2"
        icon="pi pi-angle-left"
      />
      <div class="navbar-sections d-flex" #navBarSections>
        @for (navBarItem of navBarItems; track navBarItem) {
          <div class="d-flex nav-item" id="section-{{ navBarItem.position }}" [attr.automation-id]="'navSection' + navBarItem.position | qaSlug">
            <a
              class="nav-link active pl-0"
              [ngClass]="{ active: activeNavbarItem === navBarItem.sectionType }"
              (click)="onNavBarItemClick(navBarItem)"
            >
              {{ navBarItem.text }}
            </a>
          </div>
        }
      </div>
      <p-button
        (click)="scrollNav('right')"
        [attr.automation-id]="'nav-right-scroll' | qaSlug"
        [class.d-none]="nav.isStartOfScroll && nav.isEndOfScroll"
        [disabled]="nav.isEndOfScroll"
        class="scroll-icon ms-2"
        icon="pi pi-angle-right"
      />
    </div>
  }
</nav>
